import $ from "jquery";
// 活动接口
const BASE_URL = "//eventsapi.gm99.com/activity/execute?name=gm992021&action=";
// 获取用户信息
const USER_INFO = '//passport.gm99.com/ajax/user_info';
// 登出
export const LOGOUT_URL = `//passport.gm99.com/login/logout2?forward=${encodeURIComponent(window.location.href)}`;
// 登录 pc
export const LOGIN_PAGE_PC = `//passport.gm99.com/?forward=${encodeURIComponent(window.location.href)}`;
// 登录 mobile
export const LOGIN_PAGE_MOBILE = `//passport.gm99.com/?device=2&forward=${encodeURIComponent(window.location.href)}`;

const ajax = function ({ url, data, type, dataType }) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      data: {
        params: JSON.stringify(data) || "",
      },
      type: type || "get",
      jsonp: "callback",
      dataType: dataType || "jsonp",
      success: function (res) {
        resolve(res);
      },
      fail: function () {
        reject();
      },
    });
  });
};

export const checkLogin = () => {
  return ajax({
    url: USER_INFO
  })
}

export const logout = () => {
  return ajax({
    url: LOGOUT_URL,
  })
};

// 活动接口
export const getRequest = (action, params = {}) => {
  return ajax({
    url: BASE_URL + action,
    data: params
  })
}

// 页面数据上报
export const uploadPageInfo = (params = {}) => {
  return ajax({
    url: `https://datain.octlib.com/api/v1/hw/common/event/collect?id=11&apikey=72e0e1c0-51e3-45ab-9b36-bf3b82143d9d&ext4=gm99-event&ext5=gm992021&loginAccount=${params.account}&ext1=${encodeURIComponent(window.location.href)}`
  })
}

